<div class="h-full">
  <div class="h-full flex flex-col">

    @if (currentTrip) {
    <div class="w-full h-full flex">
      <div class="w-[40%] mobile:w-full">
        <div #tripTitle class="px-8 pb-4 relative transition-all duration-150 ig-tp-flex-item text-gray-600 mobile:p-5">

          <div class="flex items-start justify-between gap-6">
            <div>
              <div class="relative flex gap-2 items-start">
                <mat-icon *ngIf="isShowingMapOnMobile" class="text-[20px] leading-[30px] cursor-pointer"
                  (click)="isShowingMapOnMobile = false">
                  west
                </mat-icon>
                <b class="font-semibold text-[20px]">{{ currentTrip.title }}</b>
              </div>
              <p *ngIf="currentTrip.days.length === 1" class="text-sm mt-2 mb-2">{{ currentTrip.days[0].dateText }}</p>
              <p *ngIf="currentTrip.days.length > 1" class="text-sm mt-2 mb-2">{{ currentTrip.days[0].dateText }}
                - {{ currentTrip.days.last().dateText }} ({{ currentTrip.days.length }}
                day{{ currentTrip.days.length > 1 ? 's' : '' }})</p>
            </div>
            <div class="flex items-center gap-3">

            </div>
          </div>

        </div>
        <div #tripContainer [class.select-none]="isDragging"
          class="ig-tp-trip-details-container ig-tp-flex-item h-[calc(100%-64px)]">

          @if (!currentTrip.days.length) {
          <p class="mt-20 text-gray-400 px-10 text-[16px] leading-6 text-center flex flex-col items-center gap-4">
            <ig-image [src]="'https://pic.rmb.bdstatic.com/bjh/user/d0283ed699ccb053bbce0789865cd9b5.jpeg'"
              cls="!w-20 !h-20 rounded-full"></ig-image>
            You haven't added any days, events or places to visit to this trip yet. You can
            start by adding a day and go to
            Events or Places and start building your itinerary.
          </p>
          }

          <mat-tab-group #daysTabGroup class="h-full relative" (selectedIndexChange)="switchDays($event)">

            @for (day of currentTrip?.days; let dayIndex = $index; track dayIndex) {

            <mat-tab [label]="day.dateText" class="cursor-pointer relative">

              <div *ngIf="isMobile" igClickStopPropagation (click)="showMobileMap(dayIndex)"
                class="absolute z-50 bottom-5 right-5 rounded-full w-16 h-16 bg-white cursor-pointer shadow-lg text-center ig-tp-trip-func mobile:bottom-16">
                <div class="relative">
                  <mat-icon *ngIf="isMobile"
                    class="!text-[32px] !leading-[64px] z-30 absolute left-2 top-0 text-gray-600">room
                  </mat-icon>

                </div>
              </div>


              <div cdkDropList (cdkDropListDropped)="onAttractionDrop($event, day)">

                @for (attraction of day.attractions; let attractionIndex = $index; track attractionIndex) {

                <ig-trip-plan-list [day]="day" [attractionIndex]="attractionIndex" [isEditMode]="isEditMode"
                  [isShowPlans]="isShowPlans"></ig-trip-plan-list>

                <div class="rounded-2xl flex h-[90px] mt-3 relative px-8 cursor-pointer" cdkDrag
                  [cdkDragDisabled]="!isEditMode" (click)="clickAttraction(attraction)" [cdkDragData]="attraction"
                  (cdkDragStarted)="isDragging=true" (cdkDragEnded)="isDragging=false"
                  [class.!cursor-grab]="isEditMode">
                  <ig-image [src]="attraction.item.cover.source" cls="w-full h-full rounded-l-2xl"
                    class="w-[calc(23%+70px)] rounded-l-2xl"></ig-image>
                  <div class="w-[77%] rounded-r-2xl bg-[#e6e6fb] py-3 px-5 relative text-xs">

                    <p class="!text-purple-400 font-semibold text-[13px] max-lines-2 !leading-4 tracking-normal">{{
                      attraction.item.name
                      }}
                      <span *ngIf="attraction.item['rating']" class="gap-1 items-start inline-flex">
                        <mat-icon class="text-[gold] !w-2.5 !h-4 !text-[12px]">star</mat-icon>
                        <span class="text-gray-500 font-normal translate-y-[-3px] text-xs">{{ attraction.item['rating']
                          }}</span>
                      </span>
                    </p>

                    <p *ngIf="attraction.item['categoryText']"
                      class="max-lines-1 !text-xs leading-5 text-gray-600 tracking-normal">{{
                      attraction.item['categoryText'] }}</p>
                    <p *ngIf="attraction.item['timeOneLine']"
                      class="max-lines-1 !text-xs leading-5 text-gray-600 tracking-normal">
                      <mat-icon *ngIf="attraction.item['isExpired']"
                        class="!w-4 !h-4 !text-[14px] !leading-5 text-red-400"
                        matTooltip="This event is expired">info</mat-icon>
                      {{ attraction.item["timeOneLine"] }}
                    </p>
                    <p class="max-lines-1 !text-xs leading-5 text-gray-600 tracking-normal">{{
                      attraction.item.address.address }}</p>

                  </div>
                  <div
                    class="rounded-full w-6 h-6 flex items-center justify-center bg-[gold] text-gray-600 font-semibold absolute left-6 -top-2.5">
                    {{ attractionIndex + 1 }}
                  </div>
                </div>
                }
              </div>

              <ig-trip-plan-list *ngIf="day.attractions.last()?.postPlans?.length" [day]="day"
                [attractionIndex]="day.attractions.length - 1" [planType]="'postPlans'" [isEditMode]="isEditMode"
                [isShowPlans]="isShowPlans"></ig-trip-plan-list>

              @if (!day.attractions.length) {
              <p class="mt-20 text-gray-400 px-10 text-[16px] leading-6 text-center flex flex-col items-center gap-4">
                <ig-image [src]="'https://pic.rmb.bdstatic.com/bjh/user/d0283ed699ccb053bbce0789865cd9b5.jpeg'"
                  cls="!w-20 !h-20 rounded-full"></ig-image>
                You haven't added any events or places to visit to this day yet. Go to
                Events or Places and start building your itinerary.
              </p>
              }
            </mat-tab>
            }

          </mat-tab-group>

        </div>
      </div>

      <div *ngIf="!isMobile || (isMobile && isShowingMapOnMobile)"
        class="w-[60%] h-full rounded-br-3xl top-[68px] left-0 mobile:z-10 mobile:absolute mobile:w-full mobile:h-[calc(100%-68px)]"
        [class.!top-[126px]]="isShowingMapOnMobile">
        <ig-google-map class="h-full w-full rounded-br-3xl" [markers]="mapMarkers" [useDefaultMarkerClickStyle]="false"
          [zoom]="4" (onMarkerClick)="markerClick($event)"></ig-google-map>
      </div>
    </div>
    } @else {
    <div class="w-full h-[80vh] flex items-center justify-center">
      <ig-spinner></ig-spinner>
    </div>
    }
  </div>
</div>
